import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import IconCheck from '@/assets/icons/heroIcons/Check.svg';
import React from 'react';
type CheckboxButtonProps = {
  label: string;
  isChecked: boolean;
  onChange: () => void;
};
export function CheckboxButton(t0) {
  const $ = _c(14);
  const {
    label,
    isChecked,
    onChange
  } = t0;
  const t1 = isChecked && "border-blue-500 bg-blue-500 text-white";
  let t2;
  if ($[0] !== t1) {
    t2 = mergeClasses("border-light-gray-500 flex h-10 cursor-pointer items-center justify-center rounded-3xl border bg-white px-4 py-2 whitespace-nowrap", "transition-all", "hover:border-blue-500 hover:bg-blue-500 hover:text-white focus:border-blue-500 focus:bg-blue-400 focus:text-white", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isChecked || $[3] !== onChange) {
    t3 = <input type="checkbox" className="hidden" checked={isChecked} onChange={onChange} />;
    $[2] = isChecked;
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isChecked) {
    t4 = isChecked && <IconCheck className="h-4 w-4" />;
    $[5] = isChecked;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== label || $[8] !== t4) {
    t5 = <span className="flex items-center gap-2">{t4}{label}</span>;
    $[7] = label;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
    t6 = <label className={t2}>{t3}{t5}</label>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}